export interface VKMiniAppLaunchUrlOptions {
  vkAppId?: string | null | undefined;
  fallbackMiniAppUrl: string;
  businessId: string;
  platform?: "vk";
  view?: "appointments" | "appointment" | null | undefined;
  appointmentId?: string | null | undefined;
  serviceId?: string | null | undefined;
  cancelApptId?: string | null | undefined;
  returnUrl?: string | null | undefined;
}

function normalizeVKAppId(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  const match = trimmed.match(/^(?:https:\/\/vk\.com\/)?(?:app)?(\d+)$/iu);
  return match?.[1] ?? null;
}

function buildLaunchParams(options: VKMiniAppLaunchUrlOptions): URLSearchParams {
  const params = new URLSearchParams();
  params.set("businessId", options.businessId);
  params.set("platform", options.platform ?? "vk");
  if (options.view) params.set("view", options.view);
  if (options.appointmentId) params.set("appointmentId", options.appointmentId);
  if (options.serviceId) params.set("serviceId", options.serviceId);
  if (options.cancelApptId) params.set("cancelApptId", options.cancelApptId);
  if (options.returnUrl) params.set("returnUrl", options.returnUrl);
  return params;
}

export function buildVkMiniAppLaunchUrl(options: VKMiniAppLaunchUrlOptions): string {
  const appId = normalizeVKAppId(options.vkAppId);
  const params = buildLaunchParams(options);

  if (appId) {
    return `https://vk.com/app${appId}#${params.toString()}`;
  }

  try {
    const url = new URL(options.fallbackMiniAppUrl);
    params.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
    return url.toString();
  } catch {
    const base = options.fallbackMiniAppUrl.replace(/\/$/, "");
    const separator = base.includes("?") ? "&" : "?";
    return `${base}${separator}${params.toString()}`;
  }
}
